// extracted by mini-css-extract-plugin
export default {"Ad":"AdPlaceholder-module__Ad__rqX14","Placeholder":"AdPlaceholder-module__Placeholder__nxdxK"};